import ReleaseApplicationPage from "@/client/components/pages/Studio/apply";

export default ReleaseApplicationPage;
